import type { FC } from "react";
import { useEffect } from "react";

import clsx from "clsx";

import type { IComponentAjax } from "@Components/ComponentAjax";
import useAjax from "@Components/Hooks/useAjax";
import { Loading } from "@Components/Loading";

import type { INavigationModalActions } from "../common/NavigationModal";
import type { IUserCommunicationTemplate } from "../common/UserCommunicationTemplate";
import UserCommunicationTemplate from "../common/UserCommunicationTemplate";

import * as css from "./VerificationPage.module.css";

export interface IVerificationPage
    extends INavigationModalActions<any>,
        IComponentAjax<IUserCommunicationTemplate> {}

export const VerificationPage: FC<IVerificationPage> = (props) => {
    const { request, isLoading, data } = useAjax(props);

    useEffect(() => {
        request();
    }, []);

    return (
        <div className={clsx(props.className, css.verificationPageComponent)}>
            <div className={css.pageContent}>
                {!isLoading && data && <UserCommunicationTemplate {...data} />}
                {isLoading && <Loading isModal />}
            </div>
        </div>
    );
};
